module.exports = __webpack_public_path__ + "img/l3.7bacfcd8.jpg";